<template>
  <div id="filesAdd">
     <v-container class="pa-0">
      <v-layout style="min-height:70px;">
      <v-flex md6>
        <v-btn fab absolute to="/files" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" to="/files">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
     </v-container>
    <v-form ref="fileAdd">
      <v-container>
        <v-layout wrap row>
        <v-flex class="xs12 sm6 md7" v-for="(file, index) of uploadingFile" :key="index">
            <v-textarea
          name="input-7-11"
          :label="getLable(file.name, 'Desc')"
          :rules="rules"
          :placeholder="file.name"
          class="required  pr-4 pl-4"
          clearable
          no-resize
          v-model="fileDesc[index]"
          @click="selectedData=true"
          hint="File description is required"
        ></v-textarea>
        </v-flex>
        <v-flex class="xs12 sm6 md7" v-for="(file, index) of uploadingFile" :key="`category${index}`">
            <v-select 
              v-model="categoryIds[index]"
              @change="changedData" 
              :items="fileCategoryList"
              item-text="name"
              item-value="id"
              :label="getLable(file.name, 'Cate')"
              :rules="[category.Rule]"
              class="required pr-4 pl-4"
            >
            </v-select>
          </v-flex>
        <v-flex class="xs12 sm6 md7" v-if="!uploadingFile.length">
            <upload-btn multiple @file-update="fileSelected($event)" title="Select file(s)" maxWidth="200px">
            <template slot="icon">
                <v-icon right dark>cloud_upload</v-icon>
            </template>
            <template slot="text-field"></template>
            </upload-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
        </v-flex>
      </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/files">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store config */  
import { getCollection, remove, uploadFile, formatDate } from '../../helpers/helpers';
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { file } from '@babel/types';

export default {
  name: 'filesAdd',
  components: {
    'upload-btn': UploadButton,
  },  
  data: () => ({
    extraParams: {},
    fileDesc: [],
    categoryIds: [],
    uploadingFile: [],
    config: config,
    selectedData: false,
    TaskModel: {
      name: '',
      membership: '',
    },
    rules: [
      v => !!v || 'File description is required',
      v => !!v || 'Please select recipient',
    ],
    category: {
      Rule: (v) => !!v || 'Please select category',
    },
  }),
  computed: {
    fileCategoryList: {
      get () {
        return store.state.FileCategory;
      },
      set (value) {
        store.commit('setFileCategory', value);
      }
    },
    File: {
      get () {
        return store.state.File;
      },
      set (value) {
        store.commit('setFile', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.getFileCategories();
  },
  methods: {
    async getFileCategories () {
      if (!this.fileCategoryList.length) {
        let entity = `FileCategory`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.fileCategoryList = data;
          }
        }
      }
    },
    getLable (name, type) {
      let label = '';
      if (type === 'Desc') {
        label = 'File Description for ';
      } else {
        label = 'Category for ';
      }
      return `${label}${name}`;
    },
    async fileSelected (files) {
      this.selectedData = true;
      this.uploadingFile = files;
    //   this.save();
    },
    async save () {
      if (this.uploadingFile.length === 0) {
        swal.fire({
          title: `<strong>Upload error</strong>`,
          type: 'error',
          html: 'File is required',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      if (this.$refs.fileAdd.validate()) {
        this.selectedData = false;
        let files = this.uploadingFile;
        for (let i = 0; i < files.length; i++) {
          if (files[i] !== 'undefined') {
            this.fileName = files[i].name;
            if (this.fileName.lastIndexOf('.') <= 0) {
              this.selectedData = true;
              return;
            }
            if (files[i].size > this.config.uploadFileSize) {
              swal.fire({
                title: `<strong>Upload error</strong>`,
                type: 'error',
                html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
                showCloseButton: true,
                showCancelButton: false,
                focusConfirm: false,
                confirmButtonText: 'Close',
              });
              this.selectedData = true;
              return;
            }
            window.getApp.$emit('AppProgress', true);
            const fr = new FileReader();
            fr.readAsDataURL(files[i]);
            fr.addEventListener('load', async () => {
              this.extraParams = {
                description: this.fileDesc[i],
                category: this.categoryIds[i]
              };
              let postUrl = 'File';
              if (session.getSession().adminUser) {
                this.extraParams.account = session.getSession().user.human.account.id;
              }
              let response = await uploadFile(postUrl, files[i], 'POST', this.extraParams);
              if (!response.$data) {
                window.getApp.$emit('AppProgress', false);
                console.log('error', response.$error);
                this.selectedData = true;
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: response.$error
                };
              } else {
                this.File.unshift(response.$data);
                if (i + 1 === files.length) {
                  swal.fire({
                    type: 'success',
                    title: 'File(s) uploaded successfully',
                    showConfirmButton: false,
                    timer: 2500,
                    onClose: () => {
                      window.getApp.$emit('AppProgress', false);
                      this.$router.push({ path: '/files' });
                    }
                  });
                }
              }
            });
          }
        }
      }
    },
    changedData () {
      this.selectedData = true;
    }
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
  #filesAdd >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Files/ParentFilesAdd.vue